import { z } from 'zod';
import { CoreNotifySubscriberContactMethodTypeSchema } from '../inputTypeSchemas/CoreNotifySubscriberContactMethodTypeSchema'
import { CoreNotifySubscriberContactMethodOriginTypeSchema } from '../inputTypeSchemas/CoreNotifySubscriberContactMethodOriginTypeSchema'
import { CoreNotifySubscriberContactMethodStatusChangeMethodTypeSchema } from '../inputTypeSchemas/CoreNotifySubscriberContactMethodStatusChangeMethodTypeSchema'
import { CoreNotifySubscriberContactMethodStatusTypeSchema } from '../inputTypeSchemas/CoreNotifySubscriberContactMethodStatusTypeSchema'

/////////////////////////////////////////
// CORE NOTIFY SUBSCRIBER CONTACT METHOD SCHEMA
/////////////////////////////////////////

export const CoreNotifySubscriberContactMethodSchema = z.object({
  type: CoreNotifySubscriberContactMethodTypeSchema,
  origin: CoreNotifySubscriberContactMethodOriginTypeSchema,
  invitedMethod: CoreNotifySubscriberContactMethodStatusChangeMethodTypeSchema.nullable(),
  optedInMethod: CoreNotifySubscriberContactMethodStatusChangeMethodTypeSchema.nullable(),
  optedOutMethod: CoreNotifySubscriberContactMethodStatusChangeMethodTypeSchema.nullable(),
  verifiedMethod: CoreNotifySubscriberContactMethodStatusChangeMethodTypeSchema.nullable(),
  status: CoreNotifySubscriberContactMethodStatusTypeSchema.nullable(),
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  identifier: z.string(),
  invitedAt: z.coerce.date().nullable(),
  optedInAt: z.coerce.date().nullable(),
  optedOutAt: z.coerce.date().nullable(),
  verifiedAt: z.coerce.date().nullable(),
  phoneNumberSMSCapable: z.boolean().nullable(),
  personId: z.number().int().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type CoreNotifySubscriberContactMethod = z.infer<typeof CoreNotifySubscriberContactMethodSchema>

export default CoreNotifySubscriberContactMethodSchema;
